<div class="content-password">
    <mat-card class="mail-card mat-elevation-z4" *ngIf="tokenValido">
        <div class="title">Activar Cuenta Profesional</div>
        <div class="subtitle">Crea tu contraseña para acceder al sistema</div>
        <form [formGroup]="activationForm" (submit)="activarCuenta()" class="example-form">
            <div class="formGroup">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Email</mat-label>
                    <input formControlName="email" type="email" matInput>
                </mat-form-field>
            </div>
            <div class="formGroup">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Contraseña</mat-label>
                    <input formControlName="password" type="password" matInput>
                </mat-form-field>
                <div class="validError">
                    <span style="color:rgb(236,75,72);" *ngIf="password.errors?.required && password.touched">
                        La contraseña es requerida
                    </span>
                    <span style="color:rgb(236,75,72);" *ngIf="password.errors?.minlength && password.touched">
                        La contraseña debe tener al menos 6 caracteres
                    </span>
                </div>
            </div>
            <div class="formGroup">
                <mat-form-field class="example-full-width input" appearance="fill">
                    <mat-label>Confirmar Contraseña</mat-label>
                    <input formControlName="password_confirmation" type="password" matInput>
                </mat-form-field>
                <div class="validError">
                    <span style="color:rgb(236,75,72);" *ngIf="activationForm.hasError('passwordError') && password_confirmation.touched">
                        Las contraseñas deben ser iguales
                    </span>
                </div>
            </div>
            <div class="divButton">
                <button type="submit" mat-raised-button color="primary" class="enviar" [disabled]="!activationForm.valid">
                    Activar Cuenta
                </button>
            </div>
        </form>
    </mat-card>

    <mat-card class="mail-card mat-elevation-z4" *ngIf="!tokenValido">
        <div class="title">Verificando token...</div>
    </mat-card>
</div>
